export const PARENT_SMS_CONSENT_LABEL_TEXT =
  'I would like to receive text message reminders from Juni before scheduled sessions.';
export const INSTRUCTOR_SMS_CONSENT_LABEL_TEXT =
  'Text messages from Juni with important reminders about my upcoming scheduled classes.';
